export default "__VITE_ASSET__DC5l$cXn__"